"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const constant_1 = require("../../constant");
const util_1 = require("../../util");
const wallet_1 = require("../../wallet");
const SWTH = {
    coinDenom: "SWTH",
    coinMinimalDenom: "swth",
    coinDecimals: 8,
    coinGeckoId: "switcheo",
    gasPriceStep: constant_1.CARBON_GAS_PRICE,
};
class LeapAccount {
    static createLeapSigner(leap, chainId) {
        const signDirect = (signerAddress, doc) => __awaiter(this, void 0, void 0, function* () {
            const signOpts = { preferNoSetFee: true };
            return yield leap.signDirect(chainId, signerAddress, doc, signOpts);
        });
        const signAmino = (signerAddress, doc) => __awaiter(this, void 0, void 0, function* () {
            const signOpts = { preferNoSetFee: true };
            return yield leap.signAmino(chainId, signerAddress, doc, signOpts);
        });
        const getAccounts = () => __awaiter(this, void 0, void 0, function* () {
            const account = yield leap.getKey(chainId);
            return [
                {
                    algo: "secp256k1",
                    address: account.bech32Address,
                    pubkey: account.pubKey,
                },
            ];
        });
        return {
            type: wallet_1.CarbonSignerTypes.BrowserInjected,
            signDirect,
            signAmino,
            getAccounts,
        };
    }
    static getChainId(configProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainId = yield configProvider.query.chain.getChainId();
            return chainId;
        });
    }
    static getChainInfo(configProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = configProvider.getConfig();
            const bech32Prefix = config.Bech32Prefix;
            const chainId = yield configProvider.query.chain.getChainId();
            const gasPricesResult = yield configProvider.query.fee.MinGasPriceAll({});
            const tokenClient = configProvider.getTokenClient();
            const coingeckoIdMap = tokenClient.geckoTokenNames;
            const feeCurrencies = gasPricesResult.minGasPrices.reduce((result, price) => {
                var _a, _b, _c;
                const token = tokenClient.tokenForDenom(price.denom);
                if (!token || token.denom === "swth")
                    return result;
                // Check if gas price is valid, else add default
                const gasPriceAdjusted = util_1.NumberUtils.bnOrZero(price.gasPrice).shiftedBy(-constant_1.decTypeDecimals);
                const minGasPrice = gasPriceAdjusted.isNaN() || gasPriceAdjusted.isZero()
                    ? (_b = (_a = LeapAccount.BASE_CHAIN_INFO.gasPriceStep) === null || _a === void 0 ? void 0 : _a.low) !== null && _b !== void 0 ? _b : constant_1.CARBON_GAS_PRICE.low
                    : gasPriceAdjusted.toNumber();
                result.push({
                    coinDenom: (_c = token.symbol) !== null && _c !== void 0 ? _c : token.denom,
                    coinMinimalDenom: token.denom,
                    coinDecimals: token.decimals.toNumber(),
                    coinGeckoId: coingeckoIdMap[token.denom],
                    gasPriceStep: {
                        low: minGasPrice,
                        average: minGasPrice,
                        high: minGasPrice,
                    },
                });
                return result;
            }, []);
            return {
                feeCurrencies: [LeapAccount.SWTH_CURRENCY, ...feeCurrencies],
                bip44: LeapAccount.BASE_CHAIN_INFO.bip44,
                currencies: [LeapAccount.SWTH_CURRENCY, ...feeCurrencies],
                stakeCurrency: LeapAccount.SWTH_CURRENCY,
                rest: config.restUrl,
                rpc: config.tmRpcUrl,
                chainName: config.network === constant_1.Network.MainNet ? `Carbon` : `Carbon (${config.network})`,
                chainId: chainId,
                bech32Config: {
                    bech32PrefixAccAddr: `${bech32Prefix}`,
                    bech32PrefixAccPub: `${bech32Prefix}pub`,
                    bech32PrefixValAddr: `${bech32Prefix}valoper`,
                    bech32PrefixValPub: `${bech32Prefix}valoperpub`,
                    bech32PrefixConsAddr: `${bech32Prefix}valcons`,
                    bech32PrefixConsPub: `${bech32Prefix}valconspub`,
                },
                features: ["stargate", "ibc-transfer", "ibc-go"],
            };
        });
    }
}
LeapAccount.SWTH_CURRENCY = SWTH;
LeapAccount.BASE_CHAIN_INFO = {
    bip44: { coinType: util_1.AddressUtils.SWTHAddress.coinType() },
    currencies: [],
    feeCurrencies: [SWTH],
    gasPriceStep: SWTH.gasPriceStep,
};
exports.default = LeapAccount;
